module.exports = __webpack_public_path__ + "static/media/explosionGIF.a1076369.gif";